function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu/Iconen/Meldingen-blauw",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#425CD4",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 29.5,
  height: 29.5
}), /*#__PURE__*/React.createElement("g", {
  id: "alarm-bell",
  transform: "translate(4.000000, 0.000000)",
  stroke: "#425CD4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.38095238,25.288 C8.72216227,26.5400089 9.78861945,27.4 11,27.4 C12.2113806,27.4 13.2778377,26.5400089 13.6190476,25.288",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11,
  y1: 4.168,
  x2: 11,
  y2: 0.418,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,4.168 C16.0626102,4.168 20.1666667,8.22046261 20.1666667,13.2194286 C20.1666667,21.722944 22,23.176 22,23.176 L-1.13686838e-13,23.176 C-1.13686838e-13,23.176 1.83333333,20.8636617 1.83333333,13.2194286 C1.83333333,8.22046261 5.93738979,4.168 11,4.168 Z",
  id: "Path"
})));
function SvgNotificationsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu/Iconen/Meldingen blauw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBlue);
export default __webpack_public_path__ + "static/media/notifications_blue.103b50aacbc24db8e9a13555eeb4e268.svg";
export { ForwardRef as ReactComponent };